import { render } from "./FormsList.vue?vue&type=template&id=54699ff1"
import script from "./FormsList.vue?vue&type=script&lang=js"
export * from "./FormsList.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__